<template>
  <div class="withdrawRecord">
    <!-- 头部 -->
    <header class="header">
      <div class="header-content">
        <div class="left" @click="changego">
          <van-icon name="arrow-left" color="#fff" size="20px" />
        </div>
        <div class="title">提现记录</div>
        <div class="right">
          <span class="filter-text">筛选</span>
          <img class="filter-icon" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA4BJREFUWEftlk9oHVUUxr8zk4c8BFsQkpl3z7MJNIbaggrRoiulK9GuinaTam2LrkqKgkK6UAQVBcXoSm3V/tko3am4abUr/waKkFo0gsS5981LwdAKTTB5M6dcvS/ENHkz0/eqWby7nHvO9/3uuefeO4R1Pmid86EL2O4OdSvY8QrGcfxQkiQnieiWdsWL5IvIn77vj4Rh+MXyvGu22Bjzmog8V0S8U7FE9LpS6vmWgHEc9ydJ8hOAsgvUAC51CmKFzkYA7L7NNxqNrf39/b+1BLSTxpgXReQFF/g5Mz9yIwC11p8BeNhqE9FLSqmm55Ldqqc4iqIyEV0AsMlF7mRmK9axobW2i/7UwU0T0R2VSmVupcGa10ytVtuVpukpl/Dr/Pz8tsHBwb86QTg1NXVTuVyeBLDZ6vm+/2gYhk2vf1m0vAeNMadFZIfLOMzMr3QCUGs9BuBlp/UlMzc9rpFvCTg9Pb3V9/1zAEoArhDRFqVU1A6kMaYqIrZ9bgbQ8H3/rjAMz6+lmfmSaK3fAjDqBD5h5t3tAGqtPwbwmNMYZ+ZDrfQyAWdnZzfMzc39AqCXiMRuOTN/dT2QWusHieiMiBARXVxYWBgaGBhoeYVlArprZ7+IHHFQk0qpu4moUQRSRHqMMbZdtrmTe0ApdTRLIxegXbEx5jsA91hBz/MOVSqV8Szx5fO1Wm00TVPbLnb8oJTabnckSyMXoBWJomi753lfi4hnX5aenp6hIAguZhnY+Xq93ttoNH4GsJGIUt/37w+CwC44c+QGtEpa6w8B7HVb9IFSan+mwz8v01ER2ediP2LmJ/Pk/e2TN9DGzczM9C0uLtpKbABgK3FfGIbft9KI4/jeJEm+sZ0B4HKpVBrq6+ubyetbCNBV8RkAb+TpJdsOxphvm70L4FlmfjMvXOEK2oSJiYlSEAQ/AtjitvodAPYaWm3cLiIH3cSFer1+5/Dw8OINBXRVfArAu0WMADzNzO8VzCnWg01xrfXjAI4VNHuCmY8XzOkI4Jjnee+vZpwkyQEietXN/T+AIjJarVbfXg0wiqKDRNSc6wIuFWl5D3YrWPRUuWtm6RSv+woCiAH8scZCbwUQ/uenOIqiESI6UaT6IrKnWq2eLJJzXU+dTTLG3AbgLIBqHsM0TSPP8x5QSv2eJ355TOGfhaIG7cZ3AbsVbLcC7eav+x68CtWBZTh4OHoFAAAAAElFTkSuQmCC" alt="筛选" />
        </div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="content">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="--END--"
          @load="onLoad"
        >
          <!-- 空数据 -->
          <div class="empty-state" v-if="list.length === 0">
            <img src="@/assets/image/czbg.png" class="empty-image" alt=""/>
            <p class="empty-tip">没有任何记录</p>
            <p class="empty-subtitle">和往常一样，这里什么都没</p>
          </div>
          
          <!-- 交易记录列表 -->
          <div class="record-list" v-else>
            <div 
              class="record-item" 
              v-for="(item, index) in list" 
              :key="index"
            >
              <!-- 订单号行 -->
              <div class="order-row">
                <span class="order-label">订单编号:176122287696514</span>
                <div class="order-right">
                  <!-- <span class="order-value">{{ item.order_number || '176122287696514' }}</span> -->
                  <span class="order-status" :class="getStatusClass(item.status)">
                  {{ getStatusText(item.status, item.status_text) }}
                </span>
                </div>
              </div>

              <!-- 分割线 -->
              <div class="divider"></div>

              <!-- 金额行 -->
              <div class="amount-row">
                <span class="amount-label">金额</span>
                <span class="amount-value">{{ item.quantity }}</span>
              </div>

              <!-- 方式行 -->
              <div class="method-row" @click="toggleExpand(index)">
                <span class="method-label">方式：</span>
                <div class="method-right">
                  <span class="method-value">银行卡</span>
                  <van-icon 
                    name="arrow" 
                    color="#fff" 
                    size="16px" 
                    :style="{ transform: item.expanded ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s' }"
                  />
                </div>
              </div>

              <!-- 展开的银行卡详细信息 -->
              <div class="bank-details" v-if="item.expanded">
                <div class="bank-detail-row">
                  <span class="bank-detail-label">银行名称</span>
                  <span class="bank-detail-value">{{ item.bank_name || '工商银行' }}</span>
                </div>
                <div class="bank-detail-row">
                  <span class="bank-detail-label">银行卡支行</span>
                  <span class="bank-detail-value">{{ item.bank_branch || '北京支行' }}</span>
                </div>
                <div class="bank-detail-row">
                  <span class="bank-detail-label">银行卡号</span>
                  <span class="bank-detail-value">{{ item.bank_card || '1231231231231232' }}</span>
                </div>
                <div class="bank-detail-row">
                  <span class="bank-detail-label">姓名</span>
                  <span class="bank-detail-value">{{ item.account_name || '哈哈哈' }}</span>
                </div>
                <div class="bank-detail-row">
                  <span class="bank-detail-label">备注信息</span>
                  <span class="bank-detail-value">{{ item.beizhu || '-' }}</span>
                </div>
              </div>

              <!-- 时间行 -->
              <div class="time-row">
                <span class="time-label">时间</span>
                <span class="time-value">{{ timeStr(item.createtime) }}</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <!-- 弹出层 -->
    <van-popup
      v-model:show="show"
      position="right"
      :style="{ width: '5.88rem', height: '100%' }"
    >
      <div class="drawer-content is-open">
        <div class="my-drawer-content">
          <div>
            <p class="title">{{$t('shijian')}}</p>
            <ul class="opt-time">
              <li @click="(showTime = !showTime), (showTimeType = 0)">
                {{ begin_date ? begin_date :$t('upshijian') }}
              </li>
              <li @click="(showTime = !showTime), (showTimeType = 1)">
                {{ end_date ? end_date : $t('downshijian') }}
              </li>
            </ul>
          </div>
          <div>
            <p class="title">状态</p>
            <ul class="opt-time">
              <template v-for="(item, index) in statueList" :key="index">
                <li
                  style="color: #fff"
                  :class="index == statueActive ? 'active' : ''"
                  @click="statueActive = index"
                >
                  {{ item }}
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="my-drawer-btns">
        <van-button class="bg-fff" @click="Reset">{{$t('chongzhi')}}</van-button>
        <van-button class="bg-red" @click="BtnOk">{{$t('queren')}}</van-button>
      </div>
    </van-popup>
    <!-- 时间选择 -->
    <van-popup
      v-model:show="showTime"
      @click="showTime = false"
      :style="{ width: '100%' }"
      position="bottom"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="showGourp"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="changeTime"
      />
    </van-popup>
  </div>
</template>
<script>
import userApi from "@/api/user";
import time from "@/utils/time";
export default {
  name: "WithdrawRecord",
  components: {},
  data() {
    return {
      show: false,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      statueList: ["全部",  this.$t('CapActive.chongzhi'),  this.$t('CapActive.tixian'),  this.$t('CapActive.goumai'), this.$t('CapActive.yingli'),  this.$t('CapActive.zengsong')],
      statueActive: 0,
      showTime: false,
      minDate: new Date(2018, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      begin_date: "",
      end_date: "",
    };
  },

  methods: {
    timeStr(items) {
      return time.formatDate(items * 1000);
    },
    timeStrtow(items) {
      return time.formatDatetow(items * 1000);
    },
    formatDate(date) {
      let yy = date.getFullYear();
      let mm = date.getMonth() + 1;
      mm = mm.toString();
      let dd = date.getDate().toString();
      return yy + "-" + mm.padStart(2, 0) + "-" + dd.padStart(2, 0);
    },
    changeTime(value) {
      console.log(this.formatDate(value));
      if (this.showTimeType == 0) {
        this.begin_date = this.formatDate(value);
      } else {
        this.end_date = this.formatDate(value);
      }
    },
    Reset() {
      this.statueActive = 0;
      this.begin_date = "";
      this.end_date = "";
    },
    BtnOk() {
      this.show = false;
      this.$toast.loading({
        message: this.$t('jiazaizhong'),
        duration: 0,
        forbidClick: true,
      });
      // 使用新的接口 /api/user/transactionDetails 并传递 type=1
      // 后端已修改为不传时间默认查询所有时间
      userApi
        .transactionDetails(undefined, undefined, 1)
        .then((data) => {
          if (data.data && data.data.length) {
            // 为每个项目添加展开状态，默认都不展开，并解析mark字段
            this.list = data.data.map((item) => {
              // 解析mark字段：姓名 银行 卡号 支行
              const markParts = item.mark ? item.mark.split(' ') : [];
              const parsedBankInfo = {
                account_name: markParts[0] || '',
                bank_name: markParts[1] || '',
                bank_card: markParts[2] || '',
                bank_branch: markParts[3] || ''
              };
              
              return {
                ...item,
                expanded: false, // 所有项目默认都不展开
                // 映射API字段到组件使用的字段
                order_number: '176122287696514', // 固定显示
                status: item.status,
                status_text: item.status_text,
                quantity: item.quantity,
                createtime: item.createtime,
                // 解析后的银行信息
                ...parsedBankInfo,
                // 备注信息
                remark: item.mark || '-'
              };
            });
          } else {
            this.list = []
            this.$toast(this.$t('Tips.zanwu'));
          }
          this.loading = false;
          this.finished = true;
          this.$toast.clear();
        })
        .catch((error) => {
          console.error('API调用失败:', error);
          this.list = [];
          this.loading = false;
          this.finished = true;
          this.$toast.clear();
        });
    },
    // 切换展开/收起状态
    toggleExpand(index) {
      // 直接修改数组元素的expanded属性
      this.list[index].expanded = !this.list[index].expanded;
      // 强制更新视图
      this.$forceUpdate();
    },
    // 获取状态文本
    getStatusText(status, statusText) {
      // 优先使用API返回的status_text，如果没有则使用默认映射
      if (statusText) {
        return statusText;
      }
      const statusMap = {
        0: '申请中',
        1: '成功',
        2: '失败'
      };
      return statusMap[status] || '成功';
    },
    // 获取状态样式类
    getStatusClass(status) {
      const classMap = {
        0: 'pending',
        1: 'success', 
        2: 'failed'
      };
      return classMap[status] || 'success';
    },
    onRefresh() {
      this.refreshing = false;
      this.finished = false;
      this.loading = true;
      this.BtnOk();
    },
    changego() {
      this.$router.go(-1);
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
        this.BtnOk();
      }
    },
  },
  mounted() {
    this.onRefresh();
  },
};
</script>
<style lang="less" scoped>
.withdrawRecord {
  width: 100%;
  height: 100vh;
  background: #050925;
  display: flex;
  flex-direction: column;
}

/* 头部样式 */
.header {
  background: #161936;
  position: relative;
  z-index: 100;
  flex-shrink: 0;
}

.header-content {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.header .left,
.header .right {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.header .left {
  justify-content: flex-start;
}

.header .right {
  justify-content: flex-end;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.filter-text {
  color: #fff;
  font-size: 14px;
}

.filter-icon {
  width: 25px;
  height: 25px;
}

.header .title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

/* 内容区域 */
.content {
  flex: 1;
  overflow-y: auto;
  background: #050925;
  padding: 0 16px;
}

/* 记录列表 */
.record-list {
  padding: 16px 0;
}

.record-item {
  background: #1a243f;
  margin-bottom: 16px;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.record-item:last-child {
  margin-bottom: 0;
}

/* 订单号行样式 */
.order-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.order-label {
  color: #fff;
  font-size: 18px;
}

.order-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.order-value {
  color: #fff;
  font-size: 14px;
}

.order-status {
  padding: 4px 0;
  border-radius: 4px;
  font-size: 20px;
  font-weight: 500;
}

.order-status.success {
  background: #4b957c;
  color: #fff;
}

.order-status.pending {
  background: #ffbb33;
  color: #fff;
}

.order-status.failed {
  background: #ff4444;
  color: #fff;
}

/* 分割线 */
.divider {
  height: 1px;
  background: repeating-linear-gradient(to right, rgba(255, 255, 255, 0.3) 0px, rgba(255, 255, 255, 0.7) -2px, transparent 4px, transparent 3px);
  margin: 12px 0;
}

/* 金额行 */
.amount-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.amount-label {
  color: #fff;
  font-size: 20px;
}

.amount-value {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
}

/* 方式行 */
.method-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  cursor: pointer;
  padding: 4px 0;
  transition: background-color 0.2s;
}

.method-row:hover {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
  padding: 4px 8px;
}

.method-label {
  color: #fff;
  font-size: 20px;
}

.method-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.method-value {
  color: #fff;
  font-size: 18px;
}

/* 银行卡详细信息 */
.bank-details {
  margin-left: 20px;
  margin-bottom: 12px;
  padding: 8px 0;
}

.bank-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.bank-detail-row:last-child {
  margin-bottom: 0;
}

.bank-detail-label {
  color: #fff;
  font-size: 18px;
  min-width: 80px;
  text-align: left;
}

.bank-detail-value {
  color: #fff;
  font-size: 14px;
  text-align: right;
  flex: 1;
  margin-left: 16px;
}

/* 时间行 */
.time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.time-label {
  color: #fff;
  font-size: 20px;
}

.time-value {
  color: #fff;
  font-size: 20px;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 80px 20px;
  color: #8a8fa3;
}

.empty-image {
  width: 58%;
  display: block;
  margin: 0 auto 20px auto;
}

.empty-tip {
  font-size: 18px;
  // margin-bottom: 10px;
  color: #9c9497;
}

.empty-subtitle {
  font-size: 14px;
  color: #9c9497;
  margin: 0;
}

.settingwarp {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.slide-btn {
  padding: 0.24rem;
}
.bg-icon-filtrate {
  width: 0.4rem;
  height: 0.4rem;
  background-image: url(../assets/image/shoudian.png);
}
.bg-icon {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.1rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.right {
  right: 0.3rem !important;
}
.mescroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  flex: 1;
}
.capital-list {
  padding: 0.2rem;
}
.mescroll-empty {
  width: 100%;
  padding-top: 20px;
  text-align: center;
}
.drawer-content {
  z-index: 1;
  position: absolute;
  top: 0.88rem;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #374c7c;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
  transition: all 0.45s cubic-bezier(0.23, 1, 0.32, 1);
  visibility: hidden;
  box-shadow: 0 8px 10px -5px rgb(0 0 0 / 20%), 0 16px 24px 2px rgb(0 0 0 / 14%),
    0 6px 30px 5px rgb(0 0 0 / 12%);
}
.drawer-content.is-open {
  visibility: visible;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
.my-drawer-content {
  padding: 0.5rem;
  padding-bottom: 0.72rem;
  max-height: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  text-align: left;
  ul {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    li {
      width: 47%;
      text-align: center;
      margin-bottom: 0.3rem;
      background-color: #5078b2;
      border-radius: 6px;
      padding: 6px 0;
      font-size: 0.3rem;
      border: 1px solid #5078b2;
    }
  }
}
.title {
  margin-bottom: 0.3rem;
  font-size: 0.4rem;
}
.opt-time {
  color: #bfbfbf;
}
.active {
  border: 1px solid #fe5050 !important;
  color: #fe5050 !important;
}
.my-drawer-btns {
  position: absolute;
  width: 100%;
  bottom: 0;
  z-index: 1;
}
.bg-red {
  width: 50%;
  color: #fff;
  background-color: #7d58c6;
  border: 1px solid #7d58c6;
}
.bg-fff {
  color: #fff;
  width: 50%;
  background: rgb(191, 191, 191);
  border-color: rgb(191, 191, 191);
}
.capital-list-item:first-child {
  margin-top: 0;
}
.capital-list-item {
  background-color: #1a243f;
  margin-top: 0.4rem;
  border-radius: 3px;
  padding: 0.3rem 0.2rem;
  text-align: left;
}
.capital-list-item > div {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-size: 0.35rem;
}
.time {
  height: 0.6rem;
  line-height: 0.6rem;
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
  background-color: #30385d;
  color: #fff;
  margin-left: -0.2rem;
  padding: 0 0.16rem;
  display: inline-block;
}
.capital-list-item > div span:last-child {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: right;
}
.capital-list-item > div span:first-child {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.item-middle {
  padding: 0.2rem 0;
}
.item-bottom {
}
</style>